<template>
  <v-navigation-drawer
    :value="isOpenTemplateGallery"
    :permanent="isOpenTemplateGallery"
    :width="windowSize.x > 1280 ? 'calc(100vw - 101px)' : '100vw'"
    max-width="100vw"
    temporary
    fixed
    right
    color="grey lighten-3"
    style="z-index: 10;transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1);"
  >
    <v-card min-height="100vh" color="grey lighten-3">
      <BaseToolbar
        ref="base-toolbar"
        :dark="false"
        @close="close"
        :title="translations.title"
        type-title="icon"
        color="white"
      >
        <div class="d-flex align-center mr-5">
          <v-btn
            ref="button-import-template"
            v-if="['landing'].includes(type) ? modelId && modelType : true"
            @click="importTemplate"
            :disabled="!selectedTemplate"
            :loading="importLoading"
            color="primary"
            depressed
            tile
          >
            {{ $t('actions.import') }}
          </v-btn>
        </div>
      </BaseToolbar>
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="primary"
        absolute
        style="top: 64px;"
      />
      <v-card-text style="position: relative; overflow-y: auto;height: calc(100vh - 64px)">
        <v-container>
          <v-row class="mb-5">
            <v-col
              v-html="translations.text"
              cols="12"
              class="d-flex align-center"
            />
          </v-row>
          <v-row>
            <v-col v-if="!gallery.length" cols="12">
              <div class="text-center pa-12 my-12">
                <v-img
                  :src="require('@/assets/svg/box_empty.svg')"
                  height="150"
                  max-height="150px"
                  aspect-ratio="1"
                  contain
                />
                <div class="grey--text">
                  {{ $t('common.no_results_found') }}
                </div>
              </div>
            </v-col>
            <v-col
              v-for="(item, index) in gallery"
              :key="index"
              cols="12"
              sm="6"
              md="4"
              lg="3"
            >
              <TemplateCard
                ref="template-card"
                :value="selectedTemplate"
                :template="item"
                @change="arg => selectedTemplate = arg"
                @show="showTemplate(item.id)"
                selectabled
                show
              />
            </v-col>
          </v-row>
        </v-container>
        <div v-if="totalGallery > gallery.length" v-intersect="onIntersect" class="intersector" />
      </v-card-text>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import BaseToolbar from '@/components/BaseToolbar'
import TemplateCard from '@/components/Templates/TemplateCard'
import CustomPagination from '@/components/Common/CustomPagination/Index'

export default {
  components: {
    BaseToolbar,
    TemplateCard,
    CustomPagination
  },
  props: {
    type: {
      type: String,
      default: 'email'
    },
    accountType: {
      type: String,
      default: ''
    },
    projectId: { default: '' }
  },
  data () {
    return {
      loading: false,
      importLoading: false,
      search: '',
      selectedTemplate: null,
      pagination: {
        page: 1,
        itemsLength: 0,
        itemsPerPage: 12,
        itemsPerPageOptions: [
          { value: 4, text: 4 },
          { value: 8, text: 8 },
          { value: 12, text: 12 },
          { value: 24, text: 24 }
        ],
        sortByOptions: [
          { value: 'name', text: 'Nombre' },
          { value: 'created_at', text: 'Fecha de creación' },
          { value: 'updated_at', text: 'Fecha de actualización' }
        ],
        sortBy: 'name',
        sortDesc: false
      }
    }
  },
  watch: {
    isOpenTemplateGallery (newVal) {
      if (newVal) {
        this.getData()
      }
    }
  },
  computed: {
    ...mapGetters({
      windowSize: 'windowSize',
      modelId: 'templates/modelId',
      modelType: 'templates/modelType',
      gallery: 'templates/gallery',
      totalGallery: 'templates/totalGallery',
      isOpenTemplateGallery: 'templates/isOpenTemplateGallery'
    }),
    computedPagination () {
      const { pagination, totalGallery } = this
      pagination.itemsLength = totalGallery
      return pagination
    },
    translations () {
      const translations = { title: this.$t('templates.gallery.title') }
      if (this.type === 'email') {
        translations.text = this.$t('templates.gallery.text_1', { type: this.$t('templates.types.email') })
      } else if (this.type === 'landing') {
        translations.text = this.$t('templates.gallery.text_1', { type: this.$t('templates.types.landing') })
      } else if (this.type === 'pdf' && this.accountType === 'certificate') {
        translations.text = this.$t('templates.gallery.text_1', { type: this.$t('templates.types.certificate') })
      } else {
        translations.text = this.$t('templates.gallery.text_1', { type: this.$t('templates.types.pdf') })
      }
      return translations
    }
  },
  methods: {
    ...mapActions({
      getTemplate: 'templates/getTemplate',
      getGallery: 'templates/getGallery',
      cloneTemplate: 'templates/cloneTemplate',
      cloneTemplateToModel: 'templates/cloneTemplateToModel'
    }),
    ...mapMutations({
      closeTemplateGallery: 'templates/closeTemplateGallery',
      openTemplateDetails: 'templates/openTemplateDetails',
      setNewsletterTemplateId: 'automation/newsletter/setNewsletterTemplateId'
    }),
    handlerInput (arg) {
      if (!arg) { this.closeTemplateGallery() }
    },
    onIntersect (entries, observer) {
      if (entries[0].isIntersecting && !this.loading) {
        this.pagination.page += 1
        this.getData(true)
      }
    },
    async getData (push) {
      const {
        type,
        accountType,
        search,
        computedPagination
      } = this
      this.loading = true
      await this.getGallery({
        type,
        account_type: accountType,
        search,
        page: computedPagination.page,
        rowsPerPage: computedPagination.itemsPerPage,
        sortBy: computedPagination.sortBy,
        descending: computedPagination.sortDesc,
        push
      })
      this.loading = false
    },
    async showTemplate (id) {
      await this.getTemplate({ id })
      this.openTemplateDetails()
    },
    async importTemplate () {
      this.importLoading = true
      if (['landing'].includes(this.type)) {
        await this.cloneTemplateToModel({
          id: this.selectedTemplate,
          model_id: this.modelId,
          model_type: this.modelType
        })
      } else {
        await this.cloneTemplate({
          id: this.selectedTemplate
        })
      }
      if (['email'].includes(this.type)) {
        this.setNewsletterTemplateId(this.selectedTemplate)
      }
      this.importLoading = false
      this.close()
    },
    cleanData () {
      this.loading = false
      this.importLoading = false
      this.search = ''
      this.selectedTemplate = null
      this.pagination = {
        page: 1,
        itemsLength: 0,
        itemsPerPage: 12,
        itemsPerPageOptions: [
          { value: 4, text: 4 },
          { value: 8, text: 8 },
          { value: 12, text: 12 },
          { value: 24, text: 24 }
        ],
        sortByOptions: [
          { value: 'name', text: 'Nombre' },
          { value: 'created_at', text: 'Fecha de creación' },
          { value: 'updated_at', text: 'Fecha de actualización' }
        ],
        sortBy: 'name',
        sortDesc: false
      }
    },
    close () {
      this.closeTemplateGallery()
      this.cleanData()
    }
  }
}
</script>
